export class Vehicle {
  position: number[];
  speed: number;
  acceleration: number = 0;
  dt: number = 0.01;
  brakePedalParams = [-1.657, -14.46];
  width = 1.865;
  length = 4.628;
  origin = [this.width / 2, this.length];
  driverPosition = [0.528, 2.389, 1.2];

  constructor(initialKinematics: number[], dt?: number) {
    if (dt != undefined) this.dt = dt;

    this.acceleration = 0;
    this.speed = initialKinematics[1];
    this.position = [0, initialKinematics[0]];
  }

  reinit(initialKinematics: number[], dt?: number) {
    if (dt != undefined) this.dt = dt;
    this.acceleration = 0;
    this.speed = initialKinematics[1];
    this.position = [0, initialKinematics[0]];
  }

  updateKinematics(bp: number) {
    this.updateAcceleration(bp);
    // update position

    let linearDPos =
      (this.acceleration * this.dt ** 2) / 2 + this.speed * this.dt;
    if (linearDPos > 0) {
      this.position[1] = this.position[1] + linearDPos;
    }
    // update speed
    this.updateSpeed();
  }

  updateSpeed() {
    this.speed = Math.max(0, this.acceleration * this.dt + this.speed);
  }

  updateAcceleration(bp: number) {
    // brake pedal model
    let a = this.brakePedalParams[0];
    let b = this.brakePedalParams[1];
    let g = -9.81;

    let d = g - b;
    let k = d / (a - b);

    if (bp < k) {
      this.acceleration = a * bp;
    } else {
      this.acceleration = b * bp + d;
    }
  }
}
